<template>
    <b-table-lite :items="items" :fields="fields" />
</template>
<script>
    export default {
        name: 'ProjectCompletedServicesTable',
        props: {
            items: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                fields: [
                    {
                        key: 'completedService',
                        label: this.$t('Service'),
                        formatter(service) {
                            return service.external_id;
                        }
                    },
                    {
                        key: 'staff_members',
                        label: this.$t('Mitarbeiter'),
                        formatter(staffMembers) {
                            return staffMembers.join(', ')
                        }
                    },
                    {
                        key: 'notice',
                        label: this.$t('Notice')
                    }
                ]
            }
        },
    }
</script>
